module.exports = __webpack_public_path__ + "static/media/laptopIcon.2115b736.svg";